import "./styles.css";
import { useEffect, useRef } from "react";
import { Bell, Users, UserPlus, ShoppingCart, Award } from "lucide-react";
import Chart from "chart.js/auto";


const Stat = ({ icon, title, value, trend, color }) => (
  <div className="stat-card">
    <div className="stat-header">
      <div className={`stat-icon ${color}`}>{icon}</div>
      <span className={trend.startsWith("+") ? "trend-up" : "trend-down"}>
        {trend}
      </span>
    </div>
    <small>{title}</small>
    <h2>{value}</h2>
  </div>
);

const CourseRow = ({ name, students, percent, color }) => (
  <tr className="row">
    <td>{name}</td>
    <td>{students}</td>
    <td>
      <div className="progress">
        <div
          className={`progress-fill bg-${color}`}
          style={{ width: percent }}
        />
      </div>
    </td>
  </tr>
);

const DashboardMain = () => {
  const lineChartRef = useRef(null);
  const donutChartRef = useRef(null);

  useEffect(() => {
    const lineChart = new Chart(lineChartRef.current, {
      type: "line",
      data: {
        labels: ["Du", "Se", "Chor", "Pay", "Ju", "Sha", "Yak"],
        datasets: [{ data: [40, 65, 52, 88, 70, 95, 110] }]
      },
      options: { plugins: { legend: { display: false } } }
    });

    const donutChart = new Chart(donutChartRef.current, {
      type: "doughnut",
      data: {
        labels: ["Tugatgan", "Jarayonda", "Boshlamagan"],
        datasets: [{ data: [30, 60, 10] }]
      }
    });

    return () => {
      lineChart.destroy();
      donutChart.destroy();
    };
  }, []);

  return (
    <main className="dashboard">
      <header className="header">
        <h1 className="header-title">Umumiy ko‘rinish</h1>

        <div className="header-actions">
          <button className="icon-btn"><Bell /></button>
          <div className="avatar">A</div>
        </div>
      </header>

      <div className="stats-grid">
        <Stat icon={<Users />} title="Jami studentlar" value="12,450" trend="+12%" color="blue" />
        <Stat icon={<UserPlus />} title="Yangi studentlar" value="320" trend="+5%" color="green" />
        <Stat icon={<ShoppingCart />} title="Sotilgan kurslar" value="1,105" trend="-2%" color="orange" />
        <Stat icon={<Award />} title="Sertifikatlar" value="850" trend="+15%" color="purple" />
      </div>

      <div className="charts">
        <div className="card">
          <h3>Studentlar dinamikasi</h3>
          <canvas ref={lineChartRef} />
        </div>
        {/* <div className="card">
          <h3>Kurslar holati</h3>
          <canvas ref={donutChartRef} />
        </div> */}
      </div>
    </main>
  );
};

export default DashboardMain;
